import $ from "jquery";

// Expand / collapse all sections on a card form
$(document).on("click", "#expand-all-button", function(e) {
  e.preventDefault();

  const $sections = $(".card-section").find(".collapse.form-section");
  $sections.collapse("show");
});

$(document).on("click", "#collapse-all-button", function(e) {
  e.preventDefault();

  const $sections = $(".card-section").find(".collapse.form-section");
  $sections.collapse("hide");
});

// Expand / collapse all subsections
const getSubsections = (toggleSubsectionButton) => {
  const $toggleSubsectionButton = $(toggleSubsectionButton);

  const $parentSectionHeading = $toggleSubsectionButton.closest(".section-heading");

  const sectionTitleArr = $parentSectionHeading.text().split(" ");
  const filteredTitle = sectionTitleArr.filter(e => e !== "\n").filter(e => e !== "");
  const parentSectionTitle = filteredTitle[0].split("\n")[0];

  const $childSections = $(document).find(`h3:contains("${parentSectionTitle}")`).closest("section");

  const $parentSection = $toggleSubsectionButton.closest("section").find(".collapse.form-section");

  return [$parentSection, $childSections.find(".collapse.form-section")];
};
$(document).on("click", ".expand-subsections-button", function(e) {
  e.preventDefault();

  const [$parentSection, $subsections] = getSubsections(this);
  $parentSection.collapse("show");
  $subsections.collapse("show");
});
$(document).on("click", ".collapse-subsections-button", function(e) {
  e.preventDefault();

  const [$parentSection, $subsections] = getSubsections(this);
  $parentSection.collapse("hide");
  $subsections.collapse("hide");
});

// Expand / collapse all nested sections
$(document).on("click", ".expand-nesteds-button", function(e) {
  e.preventDefault();

  const $nestedSections = $(this).closest(".nested-form-wrapper").find(".collapse");
  $nestedSections.collapse("show");
});

$(document).on("click", ".collapse-nesteds-button", function(e) {
  e.preventDefault();

  const $nestedSections = $(this).closest(".nested-form-wrapper").find(".collapse");
  $nestedSections.collapse("hide");
});
